import find from 'lodash/find';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';

import {
  toStructuredFromConfig
} from './config_transformer.js';

import {
  toStructuredPageContentItems
} from './transform_page_content_items.js';

import stripMissingContentFromSection
  from './transform_strip_missing_content_from_sections.js';

import removeInvalidShouldOpenOverlayFromContent 
  from './transform_remove_invalid_should_open_overlay_from_content.js';

import ensureGridSectionsHaveGridTaxonomy
  from './transform_ensure_grid_sections_have_grid_taxonomy.js';

const isConfig = (item)=>
  item.assetType == 'sections_style_configs' || item.contentType == 'sections_style_configs';


export const transformToStructuredData = (pageContentItems, { siteViewerVersionOverride = null } = {})=> {
  // returns the structured data needed by the app.

  const configItem = find(pageContentItems, isConfig);
  const nonConfigPageContentItems = filter(pageContentItems, i => !isConfig(i));
 
  if (!configItem) {
    throw Error('Missing config item in pageContentItems');
  }

  if (isEmpty(configItem.v2data)) {
    throw Error('Missing config data (v2data)');
  }

  const config = { ...configItem };

  const {
    // config
    pageConfigId,
    themeUuid,
    siteViewerVersion,
    translationsIsEnabled,
    translationsDefaultLanguageIso,
    translationsAppliedLanguages,
    // v2data
    pageScopedCss,
    isInPageSearchEnabled,
    isSecondaryLogoEnabled,
    isMobileRenderEnabled,
    socialLinks,
    shouldShowSocialLinks,
    shouldShowHeader,
    shouldShowTitle,
    menuItemsById,
    orderedMenuItemIds,
    secondaryLogoData,
    subpagesById,
    sectionsById,
    isFullBleed,
    displayAnchorLinks,
    isInlineHeaderStyle,
    headerContentPosition,
    isUsingLegacyHeader,
    sectionOverridesBySectionId
  } = toStructuredFromConfig(config, nonConfigPageContentItems);
  
  const { 
    pageContentItemsByUuid

  } = toStructuredPageContentItems(nonConfigPageContentItems, sectionsById, menuItemsById);

  const menuItemBySubpageId = {};
  forEach(menuItemsById, (menuItem) => 
    menuItemBySubpageId[menuItem.appAction.subpageId] = menuItem);

  const subpageIdBySlug = {};
  forEach(subpagesById, (subpage) => {
    // if there is no menu item for the subpage it has been deleted and the slug should be inactive
    if(subpage.slug && menuItemBySubpageId[subpage.id]){
      subpageIdBySlug[subpage.slug] = subpage.id;
    }
  });

  return {
    // config
    pageConfigId,
    themeUuid,
    siteViewerVersion: siteViewerVersionOverride || siteViewerVersion,
    translationsIsEnabled,
    translationsDefaultLanguageIso,
    translationsAppliedLanguages,
    // v2data
    pageScopedCss,
    isInPageSearchEnabled,
    isSecondaryLogoEnabled,
    isMobileRenderEnabled,
    socialLinks,
    shouldShowSocialLinks,
    shouldShowHeader,
    shouldShowTitle,
    menuItemsById,
    orderedMenuItemIds,
    secondaryLogoData,
    subpagesById,
    subpageIdBySlug,
    sectionsById: (
      ensureGridSectionsHaveGridTaxonomy(
        stripMissingContentFromSection(
          sectionsById,
          { pageContentItemsByUuid }
        )
      )
    ),
    sectionOverridesBySectionId,
    // content items
    pageContentItemsByUuid: removeInvalidShouldOpenOverlayFromContent(pageContentItemsByUuid, { sectionsById }),
    isFullBleed,
    displayAnchorLinks,
    isInlineHeaderStyle,
    headerContentPosition,
    isUsingLegacyHeader
  };

};
